/* eslint-disable max-len */
import React, { Fragment} from 'react';
import 'tw-elements';
import TableBody from './TableBody';
import { useSelector } from 'react-redux';

const Table = ({searchParams}) => {
    const CollectFeeData = useSelector(state => state.CollectFeeList);
    const { List} = CollectFeeData;
    const noSearchOrFilter = searchParams.get('search') === null && searchParams.get('filter') === null;
    return (<>
        <div className={`flex overflow-auto pb-[10px] scroll-bar px-1`} id = "search-result" >
            <table aria-label="Outside Table" className="w-full" id='admin-table'>
                <thead>
                    <tr>
                        <th class="w-[32%]">
                            <span >Student Name
                            </span>
                        </th>
                        <th class="w-[15%]">
                            <span >Class, Section
                            </span>
                        </th>
                        <th class="w-[15%]">
                            <span class="flex items-center justify-end">Pending Amount
                            </span>
                        </th>
                        <th class="w-[12%]">
                            <span class="flex items-center justify-center">Action
                            </span>
                        </th>
                    </tr>
                    <tr aria-colspan="7" class="h-1"></tr>
                            
                </thead>
                <tbody >
                </tbody>
                <tbody>
                    {List?.data?.map((item , index = 0) => (
                        <Fragment key={item._id}>
                            <TableBody
                                tableData={item}
                                indexNum={index}
                                lastIndex={List?.data?.length}
                            />
                        </Fragment>
                    ))}
                        
                </tbody>
                {List?.data?.length === 0 && (
                    <tbody>
                        <tr>
                            <td style={{ 'line-height': '100px' }} colspan="4" className="no-records-message" id='no-matching-result'>
                                {noSearchOrFilter ? `No Students found with outstanding fee` : 'No matching records found.'}
                            </td>
                        </tr>
                    </tbody>
                )}
            </table>
        </div>

    </>
    );
}

export default Table;
